import * as React from 'react';

const STORAGE_KEY = 'ai-coaching-review:scoreboard-cohort';

const readStoredCohort = (): string | null => {
	try {
		return window.localStorage.getItem(STORAGE_KEY) || null;
	} catch {
		return null;
	}
};

export function usePersistedScoreboardCohort() {
	const [cohort, setCohortState] = React.useState<string | null>(readStoredCohort);

	const setCohort = React.useCallback((next: string) => {
		setCohortState(next);
		try {
			window.localStorage.setItem(STORAGE_KEY, next);
		} catch {
			// Private mode / storage disabled: the in-memory choice still applies.
		}
	}, []);

	return [cohort, setCohort] as const;
}
